import React, { useEffect } from "react";

import styles from "./WonOverlay.module.scss";

interface Props {
  onHide?: () => void;
  timeout?: number;
  visible?: boolean;
}

const WonOverlay: React.FC<Props> = ({ onHide, timeout = 1000, visible }) => {
  useEffect(() => {
    if (!visible || !onHide) {
      return;
    }
    setTimeout(onHide, timeout);
  }, [onHide, timeout, visible]);

  return visible ? <div className={styles.container} /> : null;
};

export default WonOverlay;
